export default __webpack_public_path__ + "static/media/0059.76c63a6b.jpg";